import React, { useState } from 'react';

const timeSlots = ['8h', '9h', '10h', '11h', '12h', '13h', '14h', '15h', '16h'];

const ZoomSchedule: React.FC = () => {
  const [zoomLevel, setZoomLevel] = useState(0);

  const minSlotHeight = 60;
  const maxSlotHeight = 160;
  const slotHeight = minSlotHeight + ((maxSlotHeight - minSlotHeight) * zoomLevel + 1) / 100;

  const boxTopSlotIndex = 2; 
  const boxHeightInSlots = 1;

  return (
    <div className="tw-flex tw-h-screen tw-overflow-hidden">
      {/* Sidebar */}
      <div className="tw-relative tw-left-0 tw-top-12 tw-z-30">
        <div className="tw-pl-0 sm:tw-pl-8 tw-pt-5">
          <div
            className="tw-relative tw-flex tw-flex-col tw-rounded-full"
            style={{
              width: '1.875rem',
              background: '#4B4F5A',
              color: '#D7D8D9',
            }}
          >
            {timeSlots.map((slot, index) => (
              <div
                key={index}
                className="tw-min-w-[80px] tw-p-2 tw-flex tw-items-center tw-justify-center tw-text-sm"
                style={{
                  fontWeight: 700,
                  fontSize: '0.75em',
                  height: `${slotHeight}px`,
                }}
              >
                {slot}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Main Area */}
      <div className="tw-flex-1 tw-p-6">
        {/* Zoom control */}
        <label htmlFor="zoomSlider" className="tw-block tw-text-lg tw-font-medium tw-mb-4 ">
          Zoom Level: {zoomLevel}
        </label>
        <input
          id="zoomSlider"
          type="range"
          min={0}
          max={100}
          value={zoomLevel}
          onChange={(e) => setZoomLevel(Number(e.target.value))}
          className="tw-w-full tw-mb-6"
        />

        {/* Aligned box grid */}
        <div className="tw-flex tw-flex-col tw-border-l tw-border-gray-300">
          {timeSlots.map((_, index) => {
            const isBox = index === boxTopSlotIndex;
            return (
              <div
                key={index}
                className={`tw-relative tw-border-b tw-border-dashed tw-border-gray-300`}
                style={{ height: `${slotHeight}px` }}
              >
                {isBox && (
                  <div
                    className="tw-bg-blue-500 tw-rounded tw-w-60 tw-h-full tw-transition-all tw-duration-300"
                  />
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ZoomSchedule;
